import React from 'react';

import { flagStyles } from '../settings';

const SvgYE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5808px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgYE;
